import { SliderProps } from 'rc-slider'
import { MarkObj } from 'rc-slider/lib/Marks'

import { Icon20 } from 'builder/components/Icon'
import { TooltipV2 } from 'builder/components/Tooltip'
import * as Styles from './styles'

export type Props = { disabledTooltip?: string; withMarks?: boolean } & SliderProps

export const Slider = (props: Props) => {
  const { disabledTooltip, withMarks, ...sliderProps } = props

  const getMarks = () => {
    if (!withMarks) return
    const { min = 0, max = 100, step, value } = sliderProps
    const marks: Record<number, MarkObj> = {}

    for (let i = min; i <= max; i += step || 1) {
      const isActive = i <= (value as number)

      marks[i] = {
        style: { position: 'absolute' },
        label: <Styles.Segment $isActive={isActive} />,
      }
    }

    return marks
  }

  const handleRender: SliderProps['handleRender'] = (_, handleProps) => {
    const { min = 0, max = 100 } = props
    const position = max === min ? 0 : ((handleProps.value - min) / (max - min)) * 100

    return (
      <TooltipV2
        value={disabledTooltip}
        width={250}
        multiline={true}
        position="top"
        isActive={sliderProps.disabled && !!disabledTooltip}
      >
        <Styles.CustomHandle {...handleProps} $position={position} $disabled={sliderProps.disabled}>
          <Icon20.Drag />
        </Styles.CustomHandle>
      </TooltipV2>
    )
  }

  return <Styles.Slider {...sliderProps} handleRender={handleRender} marks={getMarks()} />
}
